export default {
  data() {
    return {
      selectedCarouselItem: null,
      imageWidth: 0,
      imageHeight: 0,
    };
  },
  methods: {
    scrollData(direction) {
      const scrollelement = this.$el.querySelector(".carousel-wrapper");
      if (!scrollelement) return;

      const amount = direction === 'left' ? -200 : 200;
      scrollelement.scrollBy(amount, 0);
    },

    scrollToCarouselItem(index) {
      this.selectedCarouselItem = 'item-' + index;
      const itemElement = document.getElementById('item-' + index);
      if (itemElement) {
        const carouselWrapper = this.$el.querySelector(".carousel-wrapper");
        if (carouselWrapper) {
          carouselWrapper.scrollTo({
            left: itemElement.offsetLeft - 50,
            behavior: 'smooth',
          });
        }
      }
    },

    tooltipStyle(id, yval, xval) {
      const w = window.innerWidth;
      if (id === 3 && w <= 768) {
        return { top: `calc(55%)`, left: `calc(-442%)` };
      }
      if (id === 1 && w <= 425) {
        return { top: `calc(${yval - 10}%)`, left: `calc(-151%)` };
      }
      if (id === 2 && w <= 425) {
        return { top: `calc(${yval - 10}%)`, left: `calc(-290%)` };
      }
      if (id === 4 && w <= 425) {
        return { top: `calc(${yval - 10}%)`, left: `calc(-138%)` };
      }
      return {
        top: `calc(${yval - 10}%)`,
        left: `calc(${xval + 5}%)`,
      };
    },

    handleMouseMove(event) {
      const rect = this.$refs.imageRef.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      for (const coord of this.coordinates) {
        if (
          x >= coord.x &&
          x <= coord.x + 5 &&
          y >= coord.y &&
          y <= coord.y + 5
        ) {
          this.showPopup = true;
          this.popupText = coord.text;
          this.popupTop = y + 2;
          this.popupLeft = x + 2;
          return;
        }
      }

      this.showPopup = false;
    },

    showTooltip(text) {
      const coord = this.coordinates.find((c) => c.text === text);
      if (coord) {
        const index = this.sectionData.section_items.findIndex(
          (item) => item.field_1 === text
        );
        if (index >= 0) {
          this.scrollToCarouselItem(index);
        }
      }
    },

    hideTooltip() {
      this.coordinates.forEach((coord) => {
        coord.showTooltip = false;
      });
    },

    handleImageLoad(event) {
      this.imageWidth = event.target.width;
      this.imageHeight = event.target.height;
    },
  },
};
